import {useState, useEffect} from 'react';
import { httpGet, APIEndpoint, EndpointType } from '../utils/apiService'
import { Company, CompaniesResponse } from '../models/CompaniesResponse'

const apiURL =  APIEndpoint(EndpointType.Companies);

export const useCompanies = (roles: string[], refreshKey: number) => {
    const [companies, setCompanies] = useState<Company[]>([])
    const [companiesError, setError] = useState("")
    const [companiesLoading, setLoading] = useState(false)

    useEffect(() => {        
        if (refreshKey <= 0) {
            return
        }

        setLoading(true)
        setError("")
        let url = apiURL
        if (roles && roles.length > 0) {
            url = url + "?roles=" + roles.join(",")
        }

        httpGet(url)
            .then((data) => {
                const companiesResponse = data as CompaniesResponse;
                
                if (companiesResponse.status == "error") {
                    setError(companiesResponse.errorMessage)
                    return
                }
                if (companiesResponse.companies) {
                    if (companiesResponse.companies.length > 0) {
                        setCompanies(companiesResponse.companies);
                    }
                } else {
                    setCompanies([]);
                }
                
            })
            .catch((error) => setError(error))
            .finally(() => setLoading(false))

    }, [roles, refreshKey]);

    return { companies, companiesLoading, companiesError };
};